import React from 'react';
import { Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import { PageSectionTitle } from 'src/components/enterprise/layout/PageSectionTitle/PageSectionTitle';
import {
  InvoiceContactFirstName,
  InvoiceContactLastName,
  InvoiceContactEmail,
  InvoiceContactPhoneNumber,
  InvoiceContactAddress,
  InvoiceContactCity,
  InvoiceContactState,
  ZipCode,
} from 'src/components/enterprise/features/Corporate/components/Form/InvoiceContactSection/InvoiceContactValidations';
import { InvoiceContactAddress2Control } from 'src/components/enterprise/features/Corporate/components/Form/InvoiceContactAddress2Control/InvoiceContactAddress2Control';
import PageSection from 'src/components/enterprise/layout/PageSection';

export const InvoiceContactSection: React.FC = () => {
  return (
    <Stack y="md">
      <PageSection>
        <Row>
          <Column phone={10}>
            <Stack y="sm">
              <PageSectionTitle title="Invoice Contact Information" />
            </Stack>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <InvoiceContactFirstName
                    name="invoiceContactFirstName"
                    id="invoiceContactFirstName"
                  />
                </Stack>
              </Column>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <InvoiceContactLastName
                    name="invoiceContactLastName"
                    id="invoiceContactLastName"
                  />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <InvoiceContactEmail
                    name="invoiceContactEmail"
                    id="invoiceContactEmail"
                  />
                </Stack>
              </Column>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <InvoiceContactPhoneNumber
                    name="invoiceContactPhoneNumber"
                    id="invoiceContactPhoneNumber"
                  />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <InvoiceContactAddress
                    name="invoiceContactAddress1"
                    id="invoiceContactAddress1"
                  />
                </Stack>
              </Column>
              <Column phone={4} gutter={12}>
                <Stack y="sm">
                  <InvoiceContactAddress2Control
                    name="invoiceContactAddress2"
                    id="invoiceContactAddress2"
                  />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <Stack y="sm">
                  <InvoiceContactCity
                    name="invoiceContactCity"
                    id="invoiceContactCity"
                  />
                </Stack>
              </Column>
              <Column phone={4} gutter={12}>
                <Stack y="sm">
                  <InvoiceContactState
                    name="invoiceContactState"
                    id="invoiceContactState"
                  />
                </Stack>
              </Column>
            </Row>
            <Row gutter={12}>
              <Column phone={6} gutter={12}>
                <ZipCode name="invoiceContactZip" id="invoiceContactZip" />
              </Column>
            </Row>
          </Column>
        </Row>
      </PageSection>
    </Stack>
  );
};
